export default __webpack_public_path__ + "static/media/image_example.6371735b.png";